export default [
  {
    title: "Joe Rogan",
    description: "On our comprehensive bloodwork",
    image: "images/testimonials/w2w-joerogan@2x.jpg",
    alt: "Joe Rogan",
    video: "https://fast.wistia.net/embed/iframe/p70cyechkr",
  },
  {
    title: "Tim Kennedy",
    description: "Professional Grappler",
    image: "images/testimonials/tim-kennedy.png",
    alt: "Tim Kennedy",
    video: "https://fast.wistia.net/embed/iframe/qv0613ks0a?videoFoam=true",
  },
  {
    title: "Amy Edwards",
    description: "Podcast Host",
    image: "images/testimonials/amy-edwards.png",
    alt: "Amy Edwards",
    video: "https://fast.wistia.net/embed/iframe/i0v87k9hzu?videoFoam=true",
  },
];
